import React from 'react';
import { RouterSwitch } from '../../components/router/switch/RouterSwitch';
import { AccountIndexPage } from './index/AccountIndexPage';
import { AccountWalletPage } from './wallet/AccountWalletPage';

export function AccountPage() {
    return (
        <RouterSwitch
            routes={[{ component: AccountIndexPage, exact: true }, AccountWalletPage]}
            redirect={AccountIndexPage.route}
        />
    );
}

AccountPage.route = '/account';
